export const iconFontAwesomeUsersPeopleHouseUser = (
	<i className="fa-solid fa-house-user"></i>
);
